{
  "name": "student",
  "version": "1.1.27",
  "author": "ClassHive Team",
  "homepage": "https://www.getclasshive.com",
  "scripts": {
    "ng": "ng",
    "start": "ionic serve",
    "sync": "ionic cap sync",
    "e2e": "ng e2e",
    "appflow:build": "CI_BUILD_NUMBER=$(($CI_BUILD_NUMBER + 10201)); if [ \"$CI_PLATFORM\" != \"web\" ]; then npx trapeze run appflow.yml -y --$CI_PLATFORM; fi && npx nx build student -c ${NG_ENV:-staging}"
  },
  "private": true,
  "description": "Digital education made simple",
  "config": {
    "ionic_generate_source_map": "true"
  },
  "browserslist": [
    "Chrome >=89",
    "ChromeAndroid >=89",
    "Firefox >=75",
    "Edge >=89",
    "Safari >=15",
    "iOS >=15"
  ]
}
